import React, {Component} from 'react'

const Jeyu = {
  Footer: {
    background: '#014852'
  },
  Color: {
    color: '#fff'
  }
}

export default class Footer extends Component {
  render() {
    return(
      <div className="container-fluid footer" style={Jeyu.Footer}>
       <div className="row">
        <div className="container">
         <div className="row">
          <p style={Jeyu.Color}>copyright &copy; 2017 <a href="https://jeyutex.com" target="_blank">JeyuTech</a> All rights reserved.</p>
         </div>
        </div>
       </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Layout/Footer.js